module.exports = __webpack_public_path__ + "img/lenta.d770088d.svg";